import { createContext, useContext } from 'react';
import { API } from '@shared/types/api';

export interface CardNavigationItem {
  entityId: string;
  channelSlug: string;
  entityVariables?: API.ListWorkflowEntitiesQueryVariables;
  backTooltip?: string;
}

export interface CardNavigationState {
  stack: CardNavigationItem[];
  currentItem?: CardNavigationItem;
  previousItem?: CardNavigationItem;
  addStackItem: (item: CardNavigationItem) => void;
  updateCurrentItem: (target: CardNavigationItem) => void;
  removeCurrentItemAfterNavigation: () => void;
  resetStack: () => void;
}

const defaultCardNavigationContext: CardNavigationState = {
  stack: [],
  currentItem: undefined,
  previousItem: undefined,
  addStackItem: () => undefined,
  updateCurrentItem: () => undefined,
  removeCurrentItemAfterNavigation: () => undefined,
  resetStack: () => undefined,
};

export const CardNavigationContext = createContext<CardNavigationState>(
  defaultCardNavigationContext,
);

export function useCardNavigationContext(): CardNavigationState {
  return useContext(CardNavigationContext);
}
